import Game from './Game';
import Instruction from './Instructions';
import Header from './Header';
import Details from './Details';

export { Game, Instruction, Header, Details };
